/**
 * Returns the current calendar year.
 */
export function getCurrentYear(): number {
  return new Date().getFullYear();
}

/**
 * Formats today's date as "Month Day(st/nd/rd/th), Year", e.g. "June 24th, 2026".
 */
export function getFullCurrentDate(): string {
  const date = new Date();
  const month = date.toLocaleString("default", { month: "long" });
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day}${getDateOrdinal(day)}, ${year}`;
}

/**
 * Returns the ordinal suffix ("st", "nd", "rd", or "th") for a day-of-month number.
 * @param day - The day of the month (1-31)
 */
function getDateOrdinal(day: number): string {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
